export const TYPE_OPTIONS = [
  { value: "agent", label: "Agent", bg: "#E8F1FD", fg: "#1D4E89" },
  { value: "realtor", label: "Realtor", bg: "#F0ECFC", fg: "#5B3FA3" },
  { value: "broker", label: "Broker", bg: "#E9EEF9", fg: "#39466B" },
  { value: "builder", label: "Builder", bg: "#F6EFE3", fg: "#8A6529" },
  { value: "developer", label: "Developer", bg: "#FCEAF1", fg: "#A23E65" },
  { value: "homeowner", label: "Homeowner", bg: "#F1F2F4", fg: "#51565F" },
  { value: "property_manager", label: "Property Manager", bg: "#E4F5F2", fg: "#1D7A6B" },
  { value: "other", label: "Other", bg: "#F1F2F4", fg: "#51565F" },
];

export const SOURCE_OPTIONS = [
  { value: "website", label: "Website" },
  { value: "referral", label: "Referral" },
  { value: "phone", label: "Phone" },
  { value: "email", label: "Email" },
  { value: "manual", label: "Manual" },
  { value: "other", label: "Other" },
];

export const SORT_OPTIONS = [
  { value: "newest", label: "Newest First" },
  { value: "oldest", label: "Oldest First" },
  { value: "name_asc", label: "Name A–Z" },
  { value: "name_desc", label: "Name Z–A" },
  { value: "most_orders", label: "Most Orders" },
  { value: "fewest_orders", label: "Fewest Orders" },
  { value: "recent_order", label: "Recent Order" },
  { value: "oldest_order", label: "Oldest Order" },
  { value: "highest_balance", label: "Highest Outstanding Balance" },
];

export const typeMeta = (value) => TYPE_OPTIONS.find((t) => t.value === value) || TYPE_OPTIONS[TYPE_OPTIONS.length - 1];

export const initials = (name = "") => name.trim().split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase() || "").join("") || "?";
export const displayName = (c) => c.name?.trim() || c.email || "Unnamed client";

export const avatarPalette = ["#E8F1FD", "#F0ECFC", "#E4F5F2", "#F6EFE3", "#FCEAF1"];
export const avatarColor = (seed = "") => avatarPalette[Math.abs([...seed].reduce((a, c) => a + c.charCodeAt(0), 0)) % avatarPalette.length];

function parseLocalDate(value) {
  if (!value) return null;
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/;
  return dateOnly.test(value) ? new Date(`${value}T00:00:00`) : new Date(value);
}

export const fmtDate = (iso) => iso ? parseLocalDate(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "No orders yet";
export const fmtDateOrDash = (iso) => iso ? parseLocalDate(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";
export const fmtCurrency = (n) => (n || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });
